import React, { Fragment, PureComponent } from 'react'
import i18n from 'i18next'
import * as R from 'ramda'
import { Redirect } from 'react-router-dom'
import Button from '../UniformComponents/Button'
import LinkButton from '../UniformComponents/LinkButton'
import PasswordInput from './components/PasswordInput'
import LoginLayout from '../components/Layouts/Login'

import './login.scss'

class PasswordResetForm extends PureComponent {
    constructor(props) {
        super(props)

        const { match } = props
        const { uuid } = match.params

        this.state = {
            password: '',
            confirmation: '',
            uuid,
            errors: [],
            redirectTo: '/passwordreset',
            showSuccess: false,
        }
    }

    isValid = () => {
        const { state } = this
        const fieldNames = ['confirmation', 'password']
        return fieldNames.map((fieldName) => (
            !R.isEmpty(state[fieldName]) && !R.isNil(state[fieldName])
        )).every((valid) => valid)
    }

    submit = async (e) => {
        const { store } = this.props
        const { csrf } = store
        const { uuid, password, confirmation } = this.state

        e.preventDefault()

        if (!this.isValid()) {
            console.log('invalid')
            return
        }

        const tryReset = await fetch(`/api/passwordreset/resetform/UUID/${uuid}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
            },
            body: JSON.stringify({
                csrf,
                password,
                confirmPassword: confirmation,
            }),
        })
        const { status } = tryReset

        try {
            if (status === 200) {
                location.href = '/'
                return
            }

            const response = await tryReset.json()

            if (status === 409) {
                const { message } = response
                store.invalidResetLink = true
                let error = 'Error resetting password'
                if (message === 'usedResetLink') {
                    error = 'This reset link has already been used'
                } else if (message === 'invalid') {
                    error = 'Invalid reset link'
                } else if (message === 'expiredResetLink') {
                    error = 'This link has expired'
                }
                this.setState({
                    errors: [error],
                })
            } else {
                this.setState({
                    errors: ['Error resetting password'],
                })
            }
        } catch (e) {
            console.error(e)
            this.setState({
                errors: ['Error resetting password'],
            })
        }
    }

    reset = (e) => {
        e.stopPropagation()
        this.setState({
            password: '',
            confirmation: '',
        })
    }

    renderErrors = () => {
        const { errors } = this.state

        return errors.length === 0
            ? null
            : (
                <div className="error-msg">
                    <div className="heading">
                        <i className="fa-regular fa-ban" />
                        <p className="msg-type">{i18n.t('reset_password_msg_error')}</p>
                    </div>
                    <p className="desc">{errors[0]}</p>
                </div>
            )
    }

    renderWarning = () => {
        const { password, confirmation } = this.state
        if (!password.match('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}$')) {
            return (
                <div className="info-msg">
                    <div className="heading">
                        <i className="fa-regular fa-ban" />
                        <p className="msg-type">{i18n.t('reset_password_msg_new_pwd')}</p>
                    </div>
                    <p className="desc">
                        {i18n.t('reset_password_msg_pwd_req_1')}
                        <br />
                        {i18n.t('reset_password_msg_pwd_req_2')}
                        <br />
                        {i18n.t('reset_password_msg_pwd_req_3')}
                    </p>
                </div>
            )
        } else if (confirmation !== password) {
            return (
                <div className="info-msg">
                    <div className="heading">
                        <i className="fa-regular fa-ban" />
                        <p className="msg-type">{i18n.t('reset_password_msg_pwd_confirm')}</p>
                    </div>
                </div>
            )
        }
        return null
    }

    redirect = () => {
        const { redirect, redirectTo } = this.state

        return redirect
            ? <Redirect to={redirectTo} />
            : null
    }

    renderForm = () => {
        const { password, confirmation } = this.state
        return (
            <Fragment>
                <h3 className="title">{i18n.t('reset_password_form_title')}</h3>
                <p className="caption">{i18n.t('reset_password_form_caption')}</p>
                <form action="/login" method="post" onSubmit={this.submit}>
                    <PasswordInput
                        cssClass="login-input light new-pwd-input"
                        label={i18n.t('reset_password_form_new_password')}
                        name="password"
                        id="password"
                        placeholder="Enter new password"
                        value={password}
                        onChange={({ value }) => this.setState({ password: value })}
                        emptyError={i18n.t('error_password')}
                        isMandatory
                    />
                    <PasswordInput
                        cssClass="login-input light confirm-pwd-input"
                        label={i18n.t('reset_password_form_confirm_password')}
                        name="confirmPassword"
                        id="confirmPassword"
                        placeholder="Enter confirm password"
                        value={confirmation}
                        onChange={({ value }) => this.setState({ confirmation: value })}
                        emptyError={i18n.t('error_password')}
                        isMandatory
                    />
                    {this.renderErrors()}
                    {this.renderWarning()}
                    <Button
                        cssClass="reset-btn primary large"
                        label={i18n.t('reset_pasword_form_update')}
                        type="submit"
                    />
                </form>
            </Fragment>
        )
    }

    renderSuccess = () => (
        <Fragment>
            <i className="success-icon fa-regular fa-circle-check" />
            <h3 className="title">{i18n.t('reset_password_success_title')}</h3>
            <p className="caption" style={{ fontSize: '14px' }}>{i18n.t('reset_password_success_caption')}</p>
            <LinkButton
                href="/login"
                cssClass="login-btn primary large"
                label={i18n.t('login_in_now', 'Login in now')}
                type="submit"
            />
        </Fragment>
    )

    render() {
        const { showSuccess } = this.state
        return (
            <Fragment>
                {this.redirect()}
                <LoginLayout>
                    <div className="pwd-wrapper">
                        {showSuccess ? this.renderSuccess() : this.renderForm()}
                    </div>
                </LoginLayout>
            </Fragment>
        )
    }
}

export default PasswordResetForm
